import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteVisitTaskAction } from '../../../../redux/actions/visitTasksActions';
import Button from '../../../shared/buttons/Button';
import Modal from '../../../shared/modal/Modal';

const DeleteVisitTaskModal = ({ onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { vin, id } = useSelector((state) => state.visit?.visit);
  const visitTask = useSelector((state) => state.visitTasks?.visitTask);

  const onSubmit = async () => {
    setLoading(true);
    await dispatch(deleteVisitTaskAction(vin, id, visitTask.id));
    setLoading(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={'Видалення послуги візиту'}
      loading={loading}
      onClose={onModalClose}
      body={'Ви дійсно бажаєте видалити цю послугу візиту?'}
      actionButton={<Button onClick={onSubmit} disabled={loading} variant={'primary'} children={'Видалити'} />}
    />
  );
};

export default DeleteVisitTaskModal;
